<script>
import ViewReservoir from "@/modules/common/views/ViewReservoir";
import api from "../api";

export default {
    name: "Reservoir",
    render(createElement) {
        return createElement(ViewReservoir, {
            props: {
                getReservoirInfos: api.reservoir.getData,
                includeWaterGates: true
            }
        });
    }
};
</script>
